import httpClient from '../../services/http-client';
import { API_SUB_URL_PATIENT, API_SUB_URL_EXPORT_CSV_FILE, API_SUB_URL_EXPORT_EXCEL_FILE } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_PATIENT, LOAD_LIST_PATIENT, LOAD_A_PATIENT, UPDATE_A_PATIENT, DELETE_A_PATIENT, 
    DOC_EXPORT_PATIENT_LIST_TO_CSV, DOC_EXPORT_PATIENT_LIST_TO_EXCEL
} from '../actionTypes';

export const apiLoadListPatient = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_PATIENT}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_PATIENT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAPatient = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_PATIENT}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_PATIENT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewPatient = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_PATIENT, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_PATIENT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAPatient = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_PATIENT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_PATIENT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAPatient = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_PATIENT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_PATIENT, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiExportPatientListToCSV = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(DOC_EXPORT_PATIENT_LIST_TO_CSV.LOADING));

        httpClient.post(`${API_SUB_URL_EXPORT_CSV_FILE}/patients`, payload, {responseType: "blob"})
            .then(response => {
                dispatch(fetchDataSuccess(DOC_EXPORT_PATIENT_LIST_TO_CSV.SUCCESS, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(DOC_EXPORT_PATIENT_LIST_TO_CSV.FAILURE, error))
            });
    }
};

export const apiExportPatientListToExcel = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(DOC_EXPORT_PATIENT_LIST_TO_EXCEL.LOADING));

        httpClient.post(`${API_SUB_URL_EXPORT_EXCEL_FILE}/patients`, payload, {responseType: "blob"})
            .then(response => {
                dispatch(fetchDataSuccess(DOC_EXPORT_PATIENT_LIST_TO_EXCEL.SUCCESS, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(DOC_EXPORT_PATIENT_LIST_TO_EXCEL.FAILURE, error))
            });
    }
};